import { OddsFormat, UserGender } from '@app/graphql'

export enum ContactFormReceiversEnum {
  tipster = 'tipster',
  appSupport = 'appSupport',
}

export interface UserDataProfile {
  avatarUrl: string;
  avatarFile?: File;
  profileBackgroundUrl: string;
  name: string;
  surname: string;
  birthday: Date;
  countryId: string;
  bio: string;
  username: string;
  email: string;
  phone: string;
  createdAt?: string;
  gender: UserGender;
  languageId?: string;
  unitValue?: number;
  unitShare?: number;
  oddsFormat?: OddsFormat;
}
